import { render } from "./Wire.vue?vue&type=template&id=6bc4ac75&scoped=true"
import script from "./Wire.vue?vue&type=script&lang=js"
export * from "./Wire.vue?vue&type=script&lang=js"

import "./Wire.vue?vue&type=style&index=0&id=6bc4ac75&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc4ac75"]])

export default __exports__